const ORIGIN_TEMPLATE_PATTERN = /\{\{origin\}\}/gi;

export const resolveOriginTemplate = (text: string): string =>
  text.replace(ORIGIN_TEMPLATE_PATTERN, window.location.origin);
